import { SERVER_URL } from '@shared/config/api/api';
import { HttpCodes } from '@shared/types/enums/http.enum';
import { StandardResponseType } from '@shared/types/global';

type FetchServerDataType<T> = {
  data?: T;
} & StandardResponseType;

export const fetchServerData = async <T>(url: string, options?: RequestInit): Promise<FetchServerDataType<T>> => {
  try {
    const response = await fetch(`${SERVER_URL}/${url}`, options);

    if (!response.ok) {
      return {
        status: response.status,
        message: response.statusText
      };
    }

    const result = await response.json();

    return { data: result as T };
  } catch (error) {
    return {
      status: HttpCodes.INTERNAL_SERVER_ERROR,
      message: error instanceof Error ? error.message : 'Network error'
    };
  }
};
